import React, { FC } from "react";
import { useTranslation } from "react-i18next";

const FinishSuccessPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="page-content">
      <h1>{t("finishSuccess.title")}</h1>
      <p>{t("finishSuccess.text")}</p>
    </div>
  );
};

export default FinishSuccessPage;
